import { Button, ListViewGroup, ListViewRow, Popover, PopoverTrigger, Stack, Text } from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';
import { PricedLineItem } from '@common/components/PricedLineItem';
import { TextCell } from '@common/components/TextCell';

interface VehicleCellProps {
	vehicleName: string;
	basePrice?: number;
	imgUrl?: string;
}

const PopoverContent = ({
	vehicleName,
	basePrice,
	imgUrl,
}: {
	vehicleName: string;
	basePrice?: number;
	imgUrl?: string;
}): React.ReactNode => {
	return (
		<Stack itemsSpacing='8'>
			<Text size='footnote' weight='semibold'>
				Vehicle
			</Text>
			<ListViewGroup>
				<ListViewRow
					bottomContent={
						<PricedLineItem
							imageUrl={imgUrl}
							primaryLabel={vehicleName}
							price={basePrice}
						/>
					}
				/>
			</ListViewGroup>
		</Stack>
	);
};

export const VehicleCell = ({ vehicleName, basePrice, imgUrl }: VehicleCellProps): React.ReactNode => {
	return (
		<PopoverTrigger>
			<Button
				className='vehicle-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<TextCell value={vehicleName} />
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent
					vehicleName={vehicleName}
					basePrice={basePrice}
					imgUrl={imgUrl}
				/>
			</Popover>
		</PopoverTrigger>
	);
};
